import React, { useState } from "react";
import "./Partnership.css";
import "../../index.css";
import { Button } from "antd";
import { partnershipStores } from "./PartnershipItem";

const PartnershipPage = () => {
  const [selectedIsland, setSelectedIsland] = useState(
    partnershipStores[0].island
  );
  const activeIslandData = partnershipStores.find(
    (item) => item.island === selectedIsland
  );

  return (
    <>
      <div className="layout partnership-layout">
        <div className="container main-partnership-container">
          <div className="partnership-background">
            <h1 className="title main-partnership-title">PARTNER STORES</h1>
            <p className="subtitle main-partnership-subtitle">
              A curated network of stores sharing our passion for premium
              cycling.
            </p>
          </div>
          <div className="partnership-container">
            <div className="island-buttons">
              {partnershipStores.map((islandData, index) => (
                <Button
                  key={index}
                  onClick={() => setSelectedIsland(islandData.island)}
                  type={
                    selectedIsland === islandData.island ? "primary" : "default"
                  }
                  className={`island-buttons-item ${
                    selectedIsland === islandData.island ? "active-button" : ""
                  }`}
                  size="large"
                >
                  {islandData.island}
                </Button>
              ))}
              {/* <Dropdown
                menu={{
                  items: partnershipStores.map((islandData, index) => ({
                    key: index,
                    label: islandData.island,
                    onClick: () => setSelectedIsland(islandData.island),
                  })),
                }}
                trigger={["click"]}
              >
                <Button size="large">
                  {selectedIsland || "Select Island"} <DownOutlined />
                </Button>
              </Dropdown> */}
            </div>

            <div className="map-container">
              <iframe
                src={activeIslandData.src}
                style={{ width: "100%", border: "none", height: "50vh" }}
                frameborder="0"
              ></iframe>
            </div>

            {/* --- Store List --- */}
            <div className="store-list">
              {activeIslandData.provinces.map((province, pIndex) =>
                province.cities.map((city, cIndex) => (
                  <div key={`${pIndex}-${cIndex}`} className="city-section">
                    <h2 className="title2 city-title ">{city.city}</h2>
                    <div className="store-grid">
                      {city.stores.map((store, sIndex) => (
                        <div key={sIndex} className="store-card">
                          <h3 className="store-name title3">{store.name}</h3>
                          <p className="store-address subtitle">
                            {store.address}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PartnershipPage;
